var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export function createExternalNavigationService(dotNetExternalNavigationService) {
    return new ExternalNavigationService(dotNetExternalNavigationService);
}
class ExternalNavigationService {
    constructor(dotNetExternalNavigationService) {
        this.dotNetExternalNavigationService = dotNetExternalNavigationService;
    }
    navigateToLocation(latitude, longitude) {
        return __awaiter(this, void 0, void 0, function* () {
            const geoUrl = `geo:${latitude},${longitude}`;
            const yandexMapsUrl = `https://yandex.ru/maps/239/sochi/?indoorLevel=1&ll=${longitude}%2C${latitude}&mode=whatshere&whatshere%5Bpoint%5D=${longitude}%2C${latitude}&whatshere%5Bzoom%5D=17&z=17`;
            if (this.isMobile()) {
                window.location.href = geoUrl;
            }
            else {
                window.open(yandexMapsUrl, '_blank');
            }
        });
    }
    navigateToWebSite(webSiteUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            window.open(webSiteUrl, '_blank');
        });
    }
    navigateToPhone(phone) {
        return __awaiter(this, void 0, void 0, function* () {
            window.location.href = `tel:${phone}`;
        });
    }
    navigateToTelegram(nickName) {
        return __awaiter(this, void 0, void 0, function* () {
            window.open(`https://t.me/${nickName}`, '_blank');
        });
    }
    navigateToWhatsApp(phone) {
        return __awaiter(this, void 0, void 0, function* () {
            window.open(`https://wa.me/${phone}`, '_blank');
        });
    }
    navigateToEmail(email) {
        return __awaiter(this, void 0, void 0, function* () {
            window.location.href = `mailto:${email}`;
        });
    }
    isMobile() {
        return /Android|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }
}
